// /*
// Copyright (c) 2009-2010, OGG - IS Kidz Africa. All rights reserved.
// */
// var OnlineGivingGateway = function (TerminalID, PAM) {
//     this.pledge.init(TerminalID, PAM);
// };

// OnlineGivingGateway.prototype.pledge = {
//     version: "1.1.3",
//     ajUrl: "//stmarys.devman.co.za/devman/external/ogg/Default.aspx",
//     jsrObj: null,
//     init: function (TerminalID, PAM) {
//         this.terminalID = TerminalID;
//         this.pam = PAM;
//         this.ccform.parent = this;
//         window.ogg = this;
//     },
//     terminalID: null,
//     pam: null,
//     lastError: null,
//     submitted: false,
//     donor: {
//         title: null,
//         initials: null,
//         firstName: null,
//         lastname: null,
//         postalAddress: null,
//         postCode: null,
//         identityNumber: null,
//         dateOfBirth: null,
//         homePhone: null,
//         workPhone: null,
//         cellPhone: null,
//         fax: null,
//         followUp: 0
//     },
//     transaction: {
//         description: "Donation",
//         amount: null,
//         repeat: 1,
//         frequency: "D",
//         currency: "zar",
//         project: "Unallocated",
//         taxCert: -1,
//         anonymous: 0
//     },
//     notify: {
//         smsNumber: null,
//         emailAddress: null
//     },

//     create: function (Title, Initials, LastName, Amount, EmailAddress) {
//         if (Title)
//             this.donor.title = Title;
//         if (Initials)
//             this.donor.initials = Initials;
//         if (LastName)
//             this.donor.lastname = LastName;
//         if (Amount)
//             this.transaction.amount = Amount;
//         if (EmailAddress)
//             this.notify.emailAddress = EmailAddress;
//         return this;
//     },

//     submit: function () {
//         this.lastError = null;
//         var request = this.ajUrl + '?' + this.preparePost({
//             v: this.version,
//             p1: this.terminalID,
//             p3: this.transaction.description,
//             p4: this.transaction.amount,
//             p6: this.transaction.repeat,
//             p7: this.transaction.frequency,
//             k1: this.transaction.project,
//             k2: this.transaction.anonymous,
//             k3: this.transaction.taxCert,
//             k4: this.donor.followUp,
//             m2: this.donor.title,
//             m3: this.donor.initials,
//             m4: this.donor.lastname,
//             m5: this.donor.postalAddress,
//             m6: this.donor.postCode,
//             m7: this.donor.identityNumber,
//             m8: this.donor.dateOfBirth,
//             m9: this.donor.workPhone ? this.donor.workPhone : this.donor.cellPhone ? this.donor.cellPhone : this.donor.homePhone,
//             m10: this.notify.emailAddress,
//             m11: this.donor.firstName,
//             m12: this.donor.fax,
//             m13: this.donor.homePhone,
//             m14: this.donor.cellPhone,
//             m15: this.donor.workPhone
//         });
//         this.jsrObj = new JSONscriptRequest(request);
//         if (this.jsrObj) {
//             this.jsrObj.buildScriptTag();
//             this.jsrObj.addScriptTag();
//             return true;
//         } else {
//             this.lastError = "Cannot create JSON Script Request.";
//             return false;
//         };
//     },

//     cbSubmit: function (result, pledge) {
//         if (!pledge) pledge = (this.jsrObj ? this : this.pledge);
//         if (pledge.jsrObj)
//             pledge.jsrObj.removeScriptTag();
//         if (result) {
//             if (!result.ok) {
//                 alert(result.message);
//             } else {
//                 pledge.transaction.reference = result.reference;
//                 if (result.vcsUrl)
//                     pledge.ccform.vcsUrl = result.vcsUrl;
//                 if (result.currency)
//                     pledge.transaction.currency = result.currency;
//                 if (pledge.transaction.reference.length > 0)
//                     return (pledge.process(pledge));
//             }
//         } else {
//             alert("No response received from gateway");
//         }
//         return false;
//     },

//     ccform: {
//         parent: null,
//         vcsUrl: "https://www.vcs.co.za/vvonline/ccform.asp",
//         pledgeForm: function () {
//             var form = document.getElementById("pledgeForm");
//             if (form == null) {
//                 form = document.createElement("FORM");
//                 form.id = "pledgeForm";
//                 form.method = "POST";
//                 form.action = this.vcsUrl;
//                 document.body.appendChild(form);
//             }
//             return form;
//         },
//         parm: function (form, name, value) {
//             try {
//                 var element = document.createElement("input");
//                 element.type = "hidden";
//                 element.name = name;
//                 if (value)
//                     element.value = value;
//                 form.appendChild(element);
//                 return element;
//             }
//             catch (ex) {
//                 alert(ex.message);
//                 return null;
//             }
//         },
//         submit: function (form) {
//             this.parent.submitted = false;
//             if (form) {
//                 form.submit();
//                 this.parent.submitted = true;
//             }
//             return this.parent.submitted;
//         }
//     },

//     process: function (pledge) {
//         var msg = pledge.ccform;
//         var form = msg.pledgeForm();
//         msg.parm(form, "p1", pledge.terminalID);
//         msg.parm(form, "p2", pledge.transaction.reference);
//         msg.parm(form, "p3", pledge.transaction.description);
//         msg.parm(form, "p4", pledge.transaction.amount);
//         msg.parm(form, "p5", pledge.transaction.currency);
//         if (pledge.transaction.repeat != 1) {
//             msg.parm(form, "p6", pledge.transaction.repeat);
//             msg.parm(form, "p7", pledge.transaction.frequency);
//         }
//         msg.parm(form, "p11", pledge.notify.emailAddress);
//         msg.parm(form, "CardholderEmail", pledge.notify.emailAddress ? pledge.notify.emailAddress : "");
//         msg.parm(form, "m_1", pledge.transaction.reference);
//         msg.parm(form, "m_2", pledge.donor.title);
//         msg.parm(form, "m_3", pledge.donor.initials);
//         msg.parm(form, "m_4", pledge.donor.lastname);
//         msg.parm(form, "m_5", pledge.donor.postalAddress);
//         msg.parm(form, "m_6", pledge.donor.postCode);
//         msg.parm(form, "m_7", pledge.donor.identityNumber);
//         msg.parm(form, "m_8", pledge.donor.dateOfBirth);
//         msg.parm(form, "m_9", (pledge.donor.workPhone ? pledge.donor.workPhone : pledge.donor.cellPhone ? pledge.donor.cellPhone : pledge.donor.homePhone));
//         msg.parm(form, "m_10", pledge.notify.emailAddress);
//         msg.submit(form);
//         if (!pledge.submitted) {
//             pledge.lastError = "Cannot process pledge until it has been submitted.  Call submit() method before process() method.";
//             return false;
//         } else {
//             return true;
//         }
//     },

//     preparePost: function (dataObject) {
//         var data = null;
//         for (var key in dataObject) {
//             if (dataObject[key])
//                 data = (data ? data + '&' : '')
//                  + key
//                  + '='
//                  + encodeURI(dataObject[key]);
//         }
//         return data;
//     },

//     urlEncode: function (plaintext) {
//         var SAFECHARS = "0123456789" +
//                         "ABCDEFGHIJKLMNOPQRSTUVWXYZ" +
//                         "abcdefghijklmnopqrstuvwxyz" +
//                         "-_.!~*'()";
//         var HEX = "0123456789ABCDEF";
//         var encoded = "";
//         for (var i = 0; i < plaintext.length; i++) {
//             var ch = plaintext.charAt(i);
//             if (ch == " ") {
//                 encoded += "+";
//             } else if (SAFECHARS.indexOf(ch) != -1) {
//                 encoded += ch;
//             } else {
//                 var charCode = ch.charCodeAt(0);
//                 if (charCode > 255) {
//                     encoded += "+";
//                 } else {
//                     encoded += "%";
//                     encoded += HEX.charAt((charCode >> 4) & 0xF);
//                     encoded += HEX.charAt(charCode & 0xF);
//                 }
//             }
//         }
//         return encoded;
//     }
// }


// function JSONscriptRequest(fullUrl) {
//     this.fullUrl = fullUrl;
//     this.noCacheIE = '&p=' + (new Date()).getTime();
//     this.headLoc = document.getElementsByTagName("head").item(0);
//     this.scriptId = 'JscriptId' + JSONscriptRequest.scriptCounter++;
// }

// JSONscriptRequest.scriptCounter = 1;
// JSONscriptRequest.prototype.buildScriptTag = function () {
//     this.scriptObj = document.createElement("script");
//     this.scriptObj.setAttribute("type", "text/javascript");
//     this.scriptObj.setAttribute("charset", "utf-8");
//     this.scriptObj.setAttribute("src", this.fullUrl + this.noCacheIE);
//     this.scriptObj.setAttribute("id", this.scriptId);
// }
// JSONscriptRequest.prototype.removeScriptTag = function () {
//     this.headLoc.removeChild(this.scriptObj);
// }
// JSONscriptRequest.prototype.addScriptTag = function () {
//     this.headLoc.appendChild(this.scriptObj);
// }


$( document ).ready(function() {

        $('#payment_method').on('change', function(){
            if($(this).val() != 'paypal'){
                $('.convertor-holder').show();
                $('.paypal-currency').hide();
            } else{
                $('.convertor-holder').hide();
                $('.paypal-currency').show();
            }
        });
        $('#currency_convert').click(function (){
            $('#currency_form').show('fast');
            $(this).hide();
            $('#close_text').show('fast');
            return false;
        });

        $('#close_text').click(function (){
            $('#currency_form').hide('fast');
            $(this).hide();
            $('#currency_convert').show('fast');
            return false;
        });

        $('#convert').click(function(){
            //Get all the values
            var amount = $('#foreign_amount').val();
            var from = $('#fromCurrency').val();
            var to = $('#toCurrency').val();

            //Make data string
            var dataString = "amount=" + amount + "&from=" + from + "&to=" + to;
            $.ajax({
                type: "POST",
                url: "/donate/converter.php",
                data: dataString,
                success: function(data){

                    //Show results div
                    $('#results').show();

                    //Put received response into result div
                    $('#results').html(data);
                }
            });
            return false;
        });


        $('#useit').click(function (){
            str = $('#results').html();
            exploded = str.split(' = ');
            //we only want the result so
            result = exploded[1].split(' ');
            //console.log();
            $('#amount').val(result[0]);
        });        
        

        $("#donation_form").validatedonation({

            rules: {
                title: "required",
                name: "required",
                surname: "required",
                email: {
                    required: true,
                    email: true
                },
                cell: 	{	required:true,
                    number:true
                },
                //postaladdres: "required",
                amount: {
                    required: true,
                    min: 1
                }
            },
            messages: {
                title: "Title is required",
                name: "Please enter your name",
                surname: "Please enter your surname",
                email: "Please enter a valid email address",
                cell: "Please enter your cellphone number"
                //postaladdres: "Please enter your postal address"
            },
            submitHandler: function(form)
            {
                ProcessDonation();
            }
        });

        $('#gift_type_unspecified:radio').click(function (){

            $("[name='programme'], [name='other_beneficiaries']").attr('disabled', true);

        });

        $('#gift_type_specified:radio, #gift_type_memory:radio').click(function (){
            $("[name='programme'], [name='other_beneficiaries']").attr('disabled', false);
        });

        //$('.programme_specific').hide();

        $("input.gift_type").click(function() {
            $('.programme_specific').hide();

            if( this.checked && $(this).attr('id') == 'gift_type_specified' ){
                $('.programme_specific').show();
            }

        });



        // var myTerminalID = '1486';
        // var pam = '';
        // var goods = 'Donation to STMARYS';

        // function SendNotification( form )
        // {
        //     var _return;
        //     $.ajax({
        //         url : '/donate/donate.php',
        //         data : form.serialize(),
        //         type : "POST",
        //         async : false,
        //         dataType : "json",
        //         error : function( data , textStatus, XHR)
        //         {
        //             console.log('error sending', data, textStatus);
        //         },
        //         success : function (data , textStatus, XHR)
        //         {
        //             console.log('success data', data );
        //             _return = data;
        //         }
        //     });
        //     console.log('notification' , _return ,form );
        //     return _return;
        // }

        // function SendRedirect (form, callback, errorCallback) {
        //     $.ajax({
        //         url : '/donate/donate.php',
        //         data : form.serialize(),
        //         type : "POST",
        //         async : false,
        //         dataType : "json",
        //         error: function( data , textStatus, XHR) {
        //             console.log('error sending', data, textStatus);

        //             if (errorCallback) {
        //                 errorCallback();
        //             }
        //         },
        //         success: function (data , textStatus, XHR) {
        //             console.log('success data:', data, textStatus );

        //             if (callback) {
        //                 callback();
        //             }
        //         }
        //     });
        //console.log('notification' , _return ,form );
    });

    // function ProcessDonation() {
    //     var ogg = new OnlineGivingGateway(myTerminalID, pam);
    //     var pledge = ogg.pledge.create(
    //         inp("name"),
    //         inp("surname"),
    //         inp("cell"),
    //         inp("amount"),
    //         inp("email")
    //         );
    //     /* pledge.donor.firstName = inp("name"); */
    //     pledge.donor.title = inp("title");
    //     pledge.donor.lastname = inp("surname");
    //     pledge.donor.firstname = inp("name");
    //     pledge.donor.identityNumber = '';
    //     pledge.donor.emailAddress = inp("email");
    //     pledge.donor.postalAddress = inp("postaladdres");

    //     pledge.notify.emailAddress = inp("email");

    //     /*pledge.donor.workPhone = inp("workNo");*/
    //     pledge.donor.cellPhone = inp("cell");
    //     pledge.transaction.frequency = "D"
    //     pledge.transaction.repeat  = 1
    //     /*pledge.donor.fax = inp("faxNo");*/

    //     switch (inp("gift_type"))
    //     {
    //         case "specified":
    //         if (inp("programme2")){
    //             pledge.transaction.project = inp("programme2");
    //             pledge.transaction.description = inp("programme2",true);
    //         } else{
    //             pledge.transaction.project = 'Unspecified';
    //             pledge.transaction.description = 'Unspecified';
    //         }

    //         break;
    //         case "memory":
    //         pledge.transaction.project = pledge.transaction.description = 'In memory of ' + inp("memory_detail");
    //         break;
    //         default:
    //         pledge.transaction.project = pledge.transaction.description = "Unspecified";
    //         break;
    //     }

//         /* override the callback submit function that handles card processing services */
//         var vcsSubmit = pledge.cbSubmit;
//         pledge.cbSubmit = function (data) {

//             try {
//                 switch (inp("payment_method")) {
//                     case "eft":

//                     var notification = SendNotification( $('#donation_form') );

//                     /* direct to EFT instructions page */
//                     document.location.href="/content/page/payment-eft";
//                     break;
//                     case "cheque":

//                     SendNotification( $('#donation_form') );

//                     /* direct to Cheque posting instructions page */
//                     document.location.href="content/page/payment-cheque";
//                     break;
//                     case "paypal":

//                     SendRedirect($('#donation_form'), function () {
//                         console.log("document.location.href=\"/content/page-payment/payment-paypal\"");

//                         document.location.href = "/content/page-payment/payment-paypal";
//                     });

//                     /* direct to Cheque posting instructions page */
//                         // setTimeout(function(){document.location.href="/content/page-payment/payment-paypal";}, 1000);

//                         break;
//                         default:
//                         vcsSubmit(data, pledge);

                        
//                     }
//                 }
//                 finally {
//                     pledge.cbSubmit = vcsSubmit;  /* restore function in case form needs to be resubmitted */
//                 }
//             }
//             /* call the submit function which will Asynchonously send that data through to DevMan and then call the cbSubmit function */
//             var submitting = pledge.submit();

//             if (!submitting) alert(pledge.lastError);
//         }

    
// });


//         function inp(id, asText) {
//             var input = document.getElementById(id);
//             if (input) {
//                 if (!input.length) {
//                     return input.value;
//                 } else {
//                     for (var i = 0; i < input.length; i++)
//                         if (input[i].selected)
//                             if (asText)
//                                 return input[i].value == "OTHER" ? inp(id + "_other", true) : input[i].text;
//                             else
//                                 return input[i].value == "OTHER" ? inp(id + "_other") : input[i].value;
//                         }
//                     } else {
//                         var radio = document.getElementsByName(id);
//                         for (var i = 0; i < radio.length; i++)
//                             if (radio[i].checked)
//                                 return radio[i].value == "OTHER" ? inp(id + "_other") : radio[i].value;
//                         }
//                         return null;
//                     }
            
